import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {Header, Titulo} from '../elementos/Header'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioCultura from './FormularioCultura'
import favicon from '../imagenes/logoutm.png'

const RegistroCultura = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                        <title>Registro de Cultura</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <Header>
                    <Titulo>Registro de Culturas</Titulo>
                    <BtnRegresar ruta="/culturas"/>
            </Header>

            <FormularioCultura />
        </>
    );
}
 
export default RegistroCultura;